
/* eslint-disable max-len */

export default `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_14)">
        <circle cx="8" cy="8" r="6.75" stroke="#D83434" stroke-width="2.5"/>
        <path d="M3 3L13 13" stroke="#D83434" stroke-width="2.5"/>
    </g>
    <defs>
        <clipPath id="clip0_1_14">
        <rect width="16" height="16" fill="white"/>
        </clipPath>
    </defs>
</svg>
`
